import React from 'react'
import {Steps,  Input, Select, DatePicker, Button, Table, Modal, message, Spin, Tabs} from 'antd'
import common from '@/public/common'
import '../returnGoods/index.less'
import {ajaxApi, fileDownloadApiNew, submitAxios} from '@/server'
import { summation, outputMoney, getCookie, getParmUrl, outformat,getCookieNew } from '../../public/utils'
import moment from 'moment'
import _,{ get } from 'lodash'
import './orderList.less'

const { Step } = Steps
const { Option } = Select
const { TabPane } = Tabs
const host = window.location.host
const urlLink = common.scpUrl + 'change-stack'

const apihost = common.scpUrl

class BuyOrderDetails extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      sping: false,
      visible: false,
      data: [],
      pageNo: 0,
      pageSize: 15,
      total: 0,
      info: null,
      search: {},
      express: [],
      whid: [],
      expTime: '',
      exportLoading:false,
    }
  }
  componentDidMount () {
    this.getDetails()
    this.getList()
  }
  // 查询订单详情
   getDetails = () => {
    //  let param = {
    //    POID: getParmUrl('POID')
    //  }
    //  ajaxApi({ // 获取详情的仓库信息
    //    url: urlLink + '/Supplier',
    //    params: {
    //      action: 'getdictionary',
    //      data: { Diction: 234 }
    //    }
    //  }).then(res => {
    //    if (res.data.error_code === 0) {
    //      this.setState({
    //        express: res.data.data
    //      })
    //    } else {
    //      message.error(res.data.error_message)
    //    }
    //  })
    //  ajaxApi({ // 获取详情的仓库信息
    //    url: urlLink + '/Purchase',
    //    params: {
    //     action: 'getwarehousebypoid',
    //     data: {PoID: getParmUrl('POID')}
    //    }
    //  }).then(res => {
    //    if (res.data.error_code === 0) {
    //      this.setState({
    //        whid: res.data.data
    //      })
    //    } else {
    //      message.error(res.data.error_message)
    //    }
    //  })
     ajaxApi({ // 获取订单状态
       url: urlLink + '/Purchase',
       params: {
         action: 'getpurchaseinfo',
         data:{POID: getParmUrl('POID'),s_code:getCookieNew('supplier_code') ? getCookieNew('supplier_code'): null}
       }
     }).then(res => {
       if (res.data.error_code === 0) {
         this.setState({
           info: res.data.data
         })
       } else {
         message.error(res.data.error_message)
       }
     })
   }
   // 获取列表信息
   getList = () => {
     this.setState({
       sping: true
     }, () => {
       let param = {
         ...this.state.search,
         po_code: getParmUrl('code')
       }
       this.getListAxios(param)
     })
   }
   getListAxios=async(params)=>{
    try{
      let res = await ajaxApi({
        url:apihost+"poInfo/detail/collection",
        params
      })
      if(get(res,'status')==200){
        const data = get(res,'data.data').map((item)=>{
          return {
            ...item,
            send_quantity: item.quantity - item.deliveryed_quantity,
            degree: item.degree ? item.degree.split(',') : [],
            astigmia: item.astigmia ? item.astigmia.split(',') : [],
            axial_position: item.axial_position ? item.axial_position.split(',') : [],
            contact_arc: item.contact_arc ? item.contact_arc.split(',') : [],
            is_conversion: item.is_conversion ? item.is_conversion.split(',') : [],
            custom_num: item.custom_num ? item.custom_num.split(',') : []
          }
        })
        // var sumInfo = {
        //   quantity:this.getSum('quantity'),
        //   price_quantity:this.getSum('price_quantity'),
        //   free_quantity:this.getSum('free_quantity'),
        //   po_settlement_amount:this.getSum('po_settlement_amount'),
        //   receipt_quantity:this.getSum('receipt_quantity'),
        //   qualified_qty:this.getSum('qualified_qty'),
        //   no_qualified_qty:this.getSum('no_qualified_qty'),
        // }
        this.setState({data})
      }
    }catch(err){console.log(err)}
    this.setState({sping:false})
   }
   // 搜索条件input框值更改
   inputChange = (name, val) => {
     let _obj = this.state.search
     _obj[name] = val.target.value
     this.setState({
       search: _obj
     })
   }
   selectChange = (name, val) => {
     let _obj = this.state.search
     _obj[name] = val
     this.setState({
       search: _obj
     })
   }
   // 搜索
   search = () => {
     this.getList()
   }
   // 确认收货弹窗选择
   receive = () => {
     this.setState({
       visible: true
     })
   }
   // 关闭确认收货弹框
   handleCancel = () => {
     this.setState({
       visible: false,
       expTime: ''
     })
   }
   // 导出
   export = async() => {
    this.setState({exportLoading:true})
    await fileDownloadApiNew({
      url:apihost+"poInfo/detail/export",
      param:{po_code:getParmUrl('code')},
      filename: getParmUrl('code') + '_' + moment(new Date()).format('YYYYMMDD') + '.xls'
    })
    this.setState({exportLoading:false})
   }
   // 打印发货单
   print = () => {
     if (this.state.data.length > 0) {
       this.props.history.push('/main/differReport/scmorderprint?POID=' + getParmUrl('POID') + '&hasErpCode='+ getParmUrl('hasErpCode'))
     }
   }
   receiveTime = (val) => {
     if (val) {
       this.setState({
         expTime: moment(val).format('YYYY-MM-DD')
       })
     } else {
       this.setState({
         expTime: ''
       })
     }
   }
   // 确认订单
   receiveModal=async()=>{
    if(!this.state.expTime){
      message.error('请选择预计发货时间')
      return
    }
    var param = [
      {
        "sid": getCookie('supplierinfo')?JSON.parse(getCookie('supplierinfo')).sid:null,
        "po_id":getParmUrl('POID'),
        "expect_date": this.state.expTime
      }
    ]
    this.setState({receiveModalLoading:true})
    _.defer(()=>{this.receiveModalAxios(param)},1000)
    
   }

   receiveModalAxios=async(param)=>{
    try{
      let res = await submitAxios({
        url: common.SapUrl + 'order/batch-confirm',
        params: param
      })
      if(res.status==200){
        message.success('确认成功')
        setTimeout(()=>{
          this.props.history.push('/waitBuyOrderDetails?POID=' + getParmUrl('POID') + '&code=' + getParmUrl('code'))
        },800)
      }
    }catch(err){
      console.log(err)
      this.setState({receiveModalLoading:false})
    }
   }
   getIsCustom=(columns)=>{
    if(getParmUrl("hasErpCode")){
      var arr = [
        {
         title: '定制片参数',
         dataIndex: 'customized_arg_list',
         align: 'left',
         width: '250px',
         render: (_, record) => (
          <div>{_?_.map(e=>{
            return <div>{e}</div>
          }):'-'}</div>
          //  <div>
          //    <div style={{display: 'flex', justifyContent: 'space-around', textAlign: 'center'}}>
          //      <div>
          //        <span>度数</span>
          //        <div>{record.degree || '--'}</div>
          //      </div>
          //      <div>
          //        <div>散光</div>
          //        <div>{record.astigmia || '--'}</div>
          //      </div>
          //      <div>
          //      <div>换算方式</div>
          //        <div>{record.is_conversion || record.is_conversion === '0' ? record.is_conversion * 1 ? '是' : '否' : '--'}</div>

          //      </div>
          //    </div>
          //    <div style={{display: 'flex', justifyContent: 'space-around', textAlign: 'center'}}>
          //    <div>
          //        <div>轴位</div>
          //        <div>{record.axial_position || '--'}</div>
          //      </div>
          //    <div>
          //        <div>基弧</div>
          //        <div>{record.contact_arc || '--'}</div>
          //      </div>
          //      <div>
          //      <div>明细数量</div>
          //        <div>{record.custom_num || '--'}</div>
          //      </div>
          //    </div>
          //   <div style={{display: 'flex', justifyContent: 'space-around', textAlign: 'center'}}>
          //     {
          //       record.ph && (
          //         <div>
          //           <div>瞳高</div>
          //           <div>{record.ph || '--'}</div>
          //         </div>
          //       )
          //     }
          //     {
          //       record.pd && (
          //         <div>
          //           <div>瞳距</div>
          //           <div>{record.pd || '--'}</div>
          //         </div>

          //       )
          //     }
          //     {
          //       record.lr && (
          //         <div>
          //           <div>左右眼</div>
          //           <div>{record.lr || '--'}</div>
          //         </div>
          //       )
          //     }
          //   </div>
          //   {
          //     record.extend_param && (
          //       <div>
          //           <div>其他参数</div>
          //           <div>{record.extend_param || '--'}</div>
          //       </div>
          //     )
          //   }
          //  </div>
         )
       },
      ]
      columns.splice(5,0,...arr)
     }
     return columns
   }
   getSum=(key)=>{
    let { data } = this.state
    if(!get(data,'length')){return 0}
    return summation(data.map(item => { return item[key]||0 }))||0
   }
   render () {
     const { data, total, sping, search, express, whid, info, visible } = this.state
     const columns = [
       {
         title: '收货仓库',
         dataIndex: 'wh_name',
         width: 120,
         align: 'center'
       },
      //  {
      //    title: '采购单号',
      //    align: 'left',
      //    dataIndex: 'POCode'
      //  },
      //  {
      //    title: '货品编码',
      //    align: 'center',
      //    dataIndex: 'ProductCode'
      //  },
      //  {
      //    title: '货品名称',
      //    dataIndex: 'ProductName',
      //    align: 'left',
      //    width: 200,
      //    render: (text) => (
      //      <span>{outformat(text)}</span>
      //    )
      //  },
        {
          title: '货品名称/货品编码',
          dataIndex: 'product_name',
          align: 'left',
          width: 180,
          render: (text,record) => (
            <span>
              {outformat(text)}<br/>
              {get(record,'product_code')}
            </span>
          )
        },
        {
 title: '供应商货品编码',
        dataIndex: 'third_product_code',
     },
       {
         title: '单位',
         dataIndex: 'unit',
         align: 'center',
         render: (text) => (
           <span>{outformat(text)}</span>
         )
       },
       {
         title: '计价数量',
          dataIndex: 'price_quantity',
         align: 'right',
         render: (text) => outformat(text||0)
       },
       {
         title: '免费数量',
         dataIndex: 'free_quantity',
         align: 'right',
         render: (text) => outformat(text||0)
       },
       {
         title: '单价',
         dataIndex: 'po_price',
         align: 'right',
          render: (text) => outputMoney(text||0, 3)
        },
        {
         title: '币种',
         dataIndex: 'base_money_type',
         align: 'center',
         render: (text) => (
           <span>{text||'--'}</span>
         )
       },
        {
          title: '金额',
          dataIndex: 'po_settlement_amount',
          align: 'right',
          render: (text) => outputMoney(text||0, 3)
        },
       {
         title: '已发数量',
         dataIndex: 'deliveryed_quantity',
         align: 'left',
         render: (text) => outformat(text||0)
       },
       {
         title: '已收数量',
         dataIndex: 'receipt_quantity',
         align: 'left',
         render: (text) => outformat(text||0)
       },
       {
         title: '已收合格数量',
         dataIndex: 'qualified_qty',
         align: 'left',
         render: (text) => outformat(text||0)
       },
       {
         title: '已收不合格数量',
         dataIndex: 'no_qualified_qty',
         align: 'left',
         render: (text) => outformat(text||0)
       }
     ]
     var status = get(info, 'status_for_supplier_name') || ''
     return (
       <div className="returnList orderDetail">
         <Spin spinning={sping}>
           <div className="search">
             <div style={{width: '60%', marginLeft: '20%'}}>
               <Steps progressDot current={info ? status === '交易完成' || status === '交易关闭' ? 4
                 : status === '视客部分确认收货' || status === '已发货，待视客收货' ? 3 : status === '视客已退货，待收货' ? 1 : status === '待确认' ? 1 : 0 : 0}>
                 <Step title="视客提交订单" />
                 <Step title="供应商确认订单" />
                 <Step title="供应商发货" />
                 <Step title="视客确认收货" />
                 <Step title="交易完成" />
               </Steps>
             </div>
           </div>
           <div className="returnBody">
             <h2 style={{fontSize: '22px'}}><span style={{fontWeight: 'bold'}}>订单状态：</span><span>{status}</span>&nbsp;<span style={{fontWeight: 'bold'}}>订单编号：</span><span>{info? info.po_code : ''}</span>
               <Button type="primary" shape="round" style={{ marginLeft: '25px', display: status=='待确认' ? 'inline-block' : 'none'}} onClick={this.receive}>确认订单</Button></h2>
             <Tabs type="card">
               <TabPane tab="货品详情" key="1">
                 <p>
                            货品编码：<Input style={{width: '200px', marginRight: '25px'}} onChange={this.inputChange.bind(this, 'product_code')} placeholder="货品编码"/>
                            货品名称：<Input style={{width: '200px', marginRight: '25px'}} onChange={this.inputChange.bind(this, 'product_name')} placeholder="货品名称"/>
                            {/* 仓库：<Select style={{width: '200px', marginRight: '25px'}} onSelect={this.selectChange.bind(this, 'WHID')} placeholder="请选择">
                     <Option value="">全部</Option>
                     {
                       whid.map(item => {
                         return <Option value={item.WHID}>{item.Name}</Option>
                       })
                     }
                   </Select> */}
                   <Button type="primary" shape="round" onClick={this.search} style={{marginRight: '25px'}}>查询</Button>
                   <Button shape="round" onClick={this.export} style={{marginRight: '25px'}} loading={this.state.exportLoading}>导出订单详情</Button>
                   <Button type="primary" shape="round" style={{marginRight: '25px'}} onClick={this.print}>打印采购单</Button>
                 </p>
                 <p>
                   <span className='sumInfo'>总数量：<span className='sumInfo_red'>{this.getSum('quantity')}</span>（计价：<span className='sumInfo_red' style={{marginRight:6}}>{this.getSum('price_quantity')}</span>免费：<span className='sumInfo_red'>{this.getSum('free_quantity')}</span>）</span>
                    <span className='sumInfo'>金额： <span className='sumInfo_red'>{outputMoney(this.getSum('po_settlement_amount')||0, 3)}</span></span>
                   <span className='sumInfo'>收货数量：<span className='sumInfo_red'>{outformat(this.getSum('receipt_quantity'))}</span></span> 
                   <span className='sumInfo'>合格数量：<span className='sumInfo_red'>{outformat(this.getSum('qualified_qty'))}</span></span>
                   <span className='sumInfo'>不合格数量：<span className='sumInfo_red'>{outformat(this.getSum('no_qualified_qty'))}</span></span></p>
                 <Table bordered columns={this.getIsCustom(columns)} dataSource={data} pagination={false} rowKey={record => record.product_id}/>
               </TabPane>
             </Tabs>
             <Modal title="确认订单"
               open={visible}
               destroyOnClose={true}
               footer={[<Button type="primary" onClick={this.receiveModal} shape="round" loading={this.state.receiveModalLoading}>确认</Button>,
                 <Button shape="round" onClick={this.handleCancel}>取消</Button>]}
               onCancel={this.handleCancel}>
               <p>期望到货日期：<DatePicker style={{width: '250px'}} defaultValue={moment(info ? moment(info.expect_date) : '2020-12-10','YYYY/MM/DD')} disabled/></p>
               <p>预计发货日期：<DatePicker style={{width: '250px'}} onChange={this.receiveTime} disabledDate={(current)=>{return current && current < moment().startOf('day')}}/></p>
             </Modal>
           </div>
         </Spin>
       </div>
     )
   }
}
export default BuyOrderDetails



// WEBPACK FOOTER //
// ./src/pages/orderAdmin/buyOrderDetails.js